/**
 * A minimal valid sketch snapshot: one document record, one page, the sketch
 * schema. What SKETCH_KIND seeds and what tests start from.
 */
import type { TLStoreSnapshot } from "@tldraw/tlschema";

import { DEFAULT_SKETCH_DOCUMENT_META } from "./meta";
import { createSketchSchema } from "./schema";

export function emptySketchSnapshot(): TLStoreSnapshot {
  const schema = createSketchSchema();
  const store = {
    "document:document": {
      id: "document:document",
      typeName: "document",
      gridSize: 10,
      name: "",
      meta: { sketch: { ...DEFAULT_SKETCH_DOCUMENT_META } },
    },
    "page:page": {
      id: "page:page",
      typeName: "page",
      name: "Page 1",
      index: "a1",
      meta: {},
    },
  };
  for (const record of Object.values(store)) {
    (schema.types as Record<string, { validate(r: unknown): unknown }>)[
      record.typeName
    ]?.validate(record);
  }
  return { store, schema: schema.serialize() } as unknown as TLStoreSnapshot;
}
